import { render, staticRenderFns } from "./BulkEditItemListItem.vue?vue&type=template&id=10c1d474"
import script from "./BulkEditItemListItem.vue?vue&type=script&lang=js"
export * from "./BulkEditItemListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports